import React from "react";
import { Card, Row, Col, Form } from "react-bootstrap";

export const ReportFilterBar = ({ filters, onFilterChange, onExport, loading }) => {
  const handleReset = () => {
    onFilterChange({
      startDate: new Date().toISOString().split("T")[0],
      endDate: new Date().toISOString().split("T")[0],
      service: ""
    });
  };

  return (
    <Card className="shadow-sm border-0 mb-4" style={{ borderRadius: "20px", backgroundColor: "#ffffff" }}>
      <Card.Body className="p-4">
        <Row className="g-3 align-items-end">
          <Col xs={12} sm={6} md={3}>
            <Form.Group>
              <Form.Label className="small fw-semibold text-muted mb-1.5" style={{ fontSize: "13px" }}>From Date</Form.Label>
              <Form.Control
                type="date"
                className="py-2 px-3 border-1"
                style={{ borderRadius: "12px", borderColor: "#e2e8f0", fontSize: "14px" }}
                value={filters.startDate}
                onChange={(e) => onFilterChange({ startDate: e.target.value })}
              />
            </Form.Group>
          </Col>
          <Col xs={12} sm={6} md={3}>
            <Form.Group>
              <Form.Label className="small fw-semibold text-muted mb-1.5" style={{ fontSize: "13px" }}>To Date</Form.Label>
              <Form.Control
                type="date"
                className="py-2 px-3 border-1"
                style={{ borderRadius: "12px", borderColor: "#e2e8f0", fontSize: "14px" }}
                value={filters.endDate}
                onChange={(e) => onFilterChange({ endDate: e.target.value })}
              />
            </Form.Group>
          </Col>
          <Col xs={12} sm={6} md={3}>
            <Form.Group>
              <Form.Label className="small fw-semibold text-muted mb-1.5" style={{ fontSize: "13px" }}>Service Type</Form.Label>
              <Form.Select
                className="py-2 px-3 border-1"
                style={{ borderRadius: "12px", borderColor: "#e2e8f0", fontSize: "14px" }}
                value={filters.service}
                onChange={(e) => onFilterChange({ service: e.target.value })}
              >
                <option value="">All Services</option>
                <option value="recharge">Mobile Recharge</option>
                <option value="dth">DTH Recharge</option>
                <option value="bbps">BBPS</option>
                <option value="aeps">AEPS</option>
                <option value="dmt">DMT</option>
                <option value="matm">MATM</option>
                <option value="fund_transfer">Fund Transfer</option>
                <option value="credit_debit">Credit / Debit</option>
              </Form.Select>
            </Form.Group>
          </Col>
          <Col xs={12} sm={6} md={3}>
            <div className="d-flex align-items-center justify-content-end" style={{ gap: "12px" }}>
              <button
                type="button"
                className="btn btn-outline-secondary d-flex align-items-center gap-2 border-1 px-3 py-2 fw-semibold w-50 justify-content-center"
                style={{ borderRadius: "12px", fontSize: "13.5px", borderColor: "#cbd5e1", color: "#475569" }}
                onClick={handleReset}
              >
                <i className="ph-bold ph-arrows-clockwise" style={{ fontSize: "16px" }}></i>
                <span>Reset</span>
              </button>

              <button
                type="button"
                className="btn border-0 text-white d-flex align-items-center gap-2 px-3 py-2 fw-semibold shadow-sm w-50 justify-content-center"
                style={{
                  borderRadius: "12px",
                  fontSize: "13.5px",
                  backgroundColor: "#7e57c2"
                }}
                onClick={onExport}
                disabled={loading}
              >
                <i className="ph-bold ph-download-simple" style={{ fontSize: "16px" }}></i>
                <span>Export CSV</span>
              </button>
            </div>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};
